import { render, staticRenderFns } from "./partner-details.vue?vue&type=template&id=69961da6&"
import script from "./partner-details.vue?vue&type=script&lang=js&"
export * from "./partner-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports